import type { SxProps, Theme } from '@mui/material/styles';

export const heroRootSx: SxProps<Theme> = {
  justifyContent: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: '#111217',
  overflow: 'hidden',
};

export const bgWrapperSx: SxProps<Theme> = {
  flexShrink: 0,
};

export const bigStarImgSx: SxProps<Theme> = {
  width: 1220, // ✅ fixe
  height: 'auto',
  position: 'absolute',
  top: '0%',
  right: '40%',
};

export const smallStarImgSx: SxProps<Theme> = {
  width: 640, // ✅ fixe
  height: 'auto',
  position: 'absolute',
  bottom: '0%',
  right: '35%',
};

export const shapeImgSx: SxProps<Theme> = {
  width: 1220, // ✅ fixe
  height: 'auto',
  position: 'absolute',
  top: '0%',
  right: '30%',
};

export const coinsWrapperSx: SxProps<Theme> = {
  position: 'relative',
  flexShrink: 0,
};

export const coinsImgSx: SxProps<Theme> = {
  width: { xs: 130, sm: 190, md: 290, lg: 440, xl: 450 },
  height: 'auto',
  display: 'block',
  pointerEvents: 'none',
  // Short viewports (laptop 1280x720 and the like): the coin, the texts and the payout carousel
  // must fit without the carousel climbing over the subtitle.
  '@media (max-height: 820px)': { width: 300 },
};

export const smallCoinImgSx: SxProps<Theme> = {
  width: { xs: 42, sm: 63, md: 105, lg: 148, xl: 180 },
  height: 'auto',
  position: 'absolute',
  top: 0,
  right: 0,
  pointerEvents: 'none',
};

export const contentStackSx: SxProps<Theme> = {
  position: 'relative',
  zIndex: 1,
  flex: 1,
  justifyContent: 'flex-start',
  alignItems: 'center',
};

export const textGroupSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  mt: { xs: '4vh', md: '6vh', xl: '8vh' },
};

export const titleSx: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: { md: '40px', lg: '48px', xl: '52px' },
  fontWeight: 'bold',
  '@media (min-width: 2560px)': { fontSize: '68px' },
  '@media (max-height: 820px)': { fontSize: '34px' },
};

export const subtitleSx: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: { md: '28px', lg: '34px', xl: '37px' },
  mt: '-1.5%',
  color: '#CCD4FF',
  '@media (min-width: 2560px)': { fontSize: '48px' },
  '@media (max-height: 820px)': { fontSize: '22px', mt: 0 },
};

export const marqueeOuterSx: SxProps<Theme> = {
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
  zIndex: 0,
  flexShrink: 0,
  mt: { md: '-6vh', lg: '-10vh', xl: '-13vh' },
  pb: { xs: 0, md: '50px', lg: '80px' },
  // No overlap on short viewports: the carousel sits below the texts.
  '@media (max-height: 820px)': { mt: '16px', pb: '24px' },
};

export const marqueeInnerSx: SxProps<Theme> = {
  display: 'flex',
  width: 'max-content',
  '@keyframes marquee': {
    '0%': { transform: 'translateX(0)' },
    '100%': { transform: 'translateX(-50%)' },
  },
  animation: 'marquee 50s linear infinite',
  willChange: 'transform',
};

export const marqueeRowSx: SxProps<Theme> = {
  flexWrap: 'nowrap',
  width: 'max-content',
};

export const marqueeRowProps = {
  direction: 'row' as const,
  gap: 4,
  px: 2,
};
